// Query keys for a project's Recent Updates and merged Activity feeds.
// Lives here rather than in each app because web and mobile had byte-identical
// copies of the recent-updates factory, which is exactly how the two drift.
/** TanStack Query key factory for the per-project Recent Updates feed. */
export const projectRecentUpdatesKeys = {
    list: (projectId) => ['project-recent-updates', projectId],
    page: (projectId, limit) => [...projectRecentUpdatesKeys.list(projectId), { page: 1, limit }],
};
/** TanStack Query key factory for the merged activity (Notifications tab) feed. */
export const projectActivityKeys = {
    list: (projectId) => ['project-activity', projectId],
    page: (projectId, limit) => [...projectActivityKeys.list(projectId), { page: 1, limit }],
};
/** Items fetched per page on both project feeds. */
export const PROJECT_FEED_PAGE_SIZE = 20;
//# sourceMappingURL=project-activity-keys.js.map